<template>
  <div class="parking-log">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>事件名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入事件名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车辆牌照</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入车辆牌照" v-model="table.search.carNumber"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>操作时间</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.date" show-time class="app-block" valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange"></a-table>
  </div>
</template>

<script>
  import ParkingService from '@/io/parking.js';

  export default {
    name: 'ParkingLog',
    props: {
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            carNumber: null,
            date: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '事件名称',
              dataIndex: 'event'
            },
            {
              title: '车辆牌照',
              dataIndex: 'carNumber'
            },
            {
              title: '房屋名称',
              dataIndex: 'housing_name'
            },
            {
              title: '住户名称',
              dataIndex: 'owner_name'
            },
            {
              title: '租/售时间',
              dataIndex: 'period_start'
            },
            {
              title: '操作时间',
              dataIndex: 'created_at'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initData();
          }
        },
        immediate: true
      }
    },
    methods: {
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          carNumber: null,
          date: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return ParkingService.log(
          this.id,
          this.table.search.name,
          this.table.search.carNumber,
          this.table.search.date,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.map(val => {
            val.carNumber = val.car_number.join('、');
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>